import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import type { OutputLayer } from '@/components/preview/output-layer-preview';

export type SimulationPreviewLayersRequest = {
  planFlowId: string;
  selectedItemIds: string[];
  showMode: 'mediaOnly' | 'both' | 'speakerOnly';
  playerType: 'stagePlayer' | 'roomPlayer' | 'onlinePlayer';
  contextSlotId?: string | null;
  contextScope?: string | null;
};

type SimulationPreviewLayersResponse = {
  layers: OutputLayer[];
};

export const useSimulationPreviewLayersMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (body: SimulationPreviewLayersRequest) => {
      const token = await getToken();
      return simulationPreviewLayers(body, token ?? '');
    },
  });
};

const simulationPreviewLayers = async (
  body: SimulationPreviewLayersRequest,
  token: string,
): Promise<SimulationPreviewLayersResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/player/simulation-preview-layers`;
  const { contextSlotId, contextScope, ...rest } = body;
  const payload: SimulationPreviewLayersRequest = { ...rest };
  if (typeof contextSlotId === 'string' && contextSlotId.length > 0) {
    payload.contextSlotId = contextSlotId;
  }
  if (typeof contextScope === 'string' && contextScope.length > 0) {
    payload.contextScope = contextScope;
  }
  return sendJSONRequest({ url, method: METHOD.POST, body: payload, token });
};
